import Vue from 'vue'
import './assets/style.css'
import App from './App.vue'
import store from './store/store';
import i18n from './libs/i18n';
import VueCarousel from 'vue-carousel';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueApexCharts from 'vue-apexcharts'

Vue.component('VueSlider', VueSlider)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
Vue.use(VueCarousel);

Vue.directive('focus', {
  inserted: function (el) {
    el.focus();
  }
});

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
